import React from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';

/**
 * Product with Organic Traffic
 */
const AtlasV2OrganicTrafficProductsSplineChart = () => {
  return (
    <AtlasV2ComparableSplineChart
      indexName="traffic"
      fieldName="stacklineSku"
      title="Products with Organic Traffic"
      requestBuilder={(builder) => builder.addConditionRangeFilter('organicClicks', 1)}
    />
  );
};

export default AtlasV2OrganicTrafficProductsSplineChart;
